module.exports = __webpack_public_path__ + "img/nav1.1839830f.png";